export default {
    title: "Antwort 1",
    jumpTo: { type: 'next', href: null, id: null, slug: null },
    iconSet: "heroicon",
    iconType: "outline",
    iconName: "BeakerIcon",
    style: { backgroundColor: null, color: null, }
}
